export const salesExecutiveDocumentJson = {
  showSaveNextBtn: false,
  screenTitle: "Sales Executive Document",
  showTitle: true,
  showCancel: false,
  showSaveBtn: false,
  fieldMeta: [],
  fieldMetaForSearch: [],
};
